export const DATA_ACCOUNT_SET = 'DATA_ACCOUNT_SET';

export const CHECK_ACC_REQUESTING = 'CHECK_ACC_REQUESTING';
export const CHECK_ACC_REQUEST_SUCCESS = 'CHECK_ACC_REQUEST_SUCCESS';
export const CHECK_ACC_REQUEST_ERROR = 'CHECK_ACC_REQUEST_ERROR';
